/**
 * 登出时清掉 AI 助手的 F5 恢复快照（F3 阶段 4 review 09-14）。
 *
 * **零依赖**：`@/api/auth` 的 `authApi.logout` 调它，那个模块刻意只 import 零运行时依赖的小模块
 * （它被 ~270 个消费者 import，别把聊天模块图拖进去）。键前缀与 `chatSessionStorage` 共用这里的常量。
 * 清完广播一个事件：还开着的浮窗据此关掉，免得登出跳转时的 pagehide 把对话写回来。
 */
export const CHAT_SNAPSHOT_KEY_PREFIX = 'ai-chat:session:'
export const CHAT_SNAPSHOTS_CLEARED_EVENT = 'ai-chat:snapshots-cleared'

export function clearAllChatSnapshots(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i)
      if (k?.startsWith(CHAT_SNAPSHOT_KEY_PREFIX)) keys.push(k)
    }
    for (const k of keys) sessionStorage.removeItem(k)
  } catch (err) {
    console.warn('[ai-chat] session snapshots not cleared on logout (storage blocked)', err)
  }
  try {
    window.dispatchEvent(new Event(CHAT_SNAPSHOTS_CLEARED_EVENT))
  } catch { /* 非浏览器环境 */ }
}
